/**
 * RepeatMode represents how a list should "repeat" (or if it shouldn't).
 */
export var RepeatMode;
(function (RepeatMode) {
    /**
     * Do not repeat the context.
     *
     * When the last track in the context ends, the first track in the context
     * order will be loaded in a paused state.
     */
    RepeatMode[RepeatMode["OFF"] = 0] = "OFF";
    /**
     * Repeat the context.
     *
     * When the last track in the context ends, the first track in tthe context
     * order will be played next.
     */
    RepeatMode[RepeatMode["CONTEXT"] = 1] = "CONTEXT";
    /**
     * Repeat the track.
     *
     * Replays the currently playing track when it ends.
     */
    RepeatMode[RepeatMode["TRACK"] = 2] = "TRACK";
})(RepeatMode || (RepeatMode = {}));
//# sourceMappingURL=repeat_mode.js.map